<template>
  <div class="sc-wrap">
    <img src="../../assets/sc_bg.png" class="sc_bg" style="height: 100%" />
    <div class="sc-box">
      <!--  标题  -->
      <div class="success-case-title">成功案例</div>
      <!--副标题-->
      <div class="success-case-sub-title">SUCCESS CASES</div>
      <!--轮播-->
      <div class="swiper-box">
        <img src="../../assets/sc/left.png" @click="changePage('prev')" />
        <div
          class="item-sc-card"
          v-for="(item, index) in list.slice(page, page + 3)"
          :key="index"
        >
          <img :src="item.url" alt="" style="width: 270px; height: 210px" />
          <div
            style="
              margin-top: 24px;
              text-align: center;
              font-size: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            "
          >
            {{ item.name }}
          </div>
        </div>
        <img src="../../assets/sc/right.png" @click="changePage('next')" />
      </div>
    </div>
  </div>
</template>
<script>
import img1 from "../../assets/success/1.jpg";
import img2 from "../../assets/success/2.jpg";
import img3 from "../../assets/success/3.jpg";
import img4 from "../../assets/success/4.jpg";
import img5 from "../../assets/success/5.jpeg";
import img6 from "../../assets/success/6.jpg";
import img7 from "../../assets/success/7.jpg";
import img8 from "../../assets/success/8.jpg";
import img9 from "../../assets/success/9.jpg";
export default {
  data() {
    return {
      height: 451,
      list: [
        { name: "蚌埠市第一人民医院", url: img1 },
        { name: "保运集团医院", url: img2 },
        { name: "北京大学人民医院", url: img3 },
        { name: "北京大学人民医院雄安健康管理中心", url: img4 },
        { name: "大同市第三人民医院", url: img5 },
        { name: "和美大健康", url: img6 },
        { name: "和谐医疗", url: img7 },
        { name: "湖南省儿童医院", url: img8 },
        { name: "唐山市协和医院体检中心", url: img9 },
      ],
      page: 0,
    };
  },
  methods: {
    changePage(type) {
      if (type === "prev") {
        if (this.page === 0) {
          return;
        }
        this.page -= 1;
      }
      if (type === "next") {
        if (this.page + 2 === this.list.length - 1) {
          return;
        }
        this.page += 1;
      }
    },
  },
};
</script>
<style scoped lang="less">
.sc-wrap {
  position: relative;
  box-sizing: border-box;
  padding-top: 100px;
}
.sc_bg {
  width: 100%;
  object-fit: contain;
  position: absolute;
  z-index: -1;
}
.sc-box {
  width: 1200px;
  margin: 0 auto;
  //background: pink;
}
.success-case-title {
  font-size: 40px;
  font-weight: bold;
  color: #ffffff;
  text-align: center;
  margin-top: 100px;
}
.success-case-sub-title {
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  margin-top: 13px;
}
.swiper-box {
  margin-top: 260px;
  width: 1200px;
  height: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .item-sc-card {
    width: 300px;
    height: 300px;
    background: #fff;
    box-sizing: border-box;
    padding: 14px;
  }
}
</style>
